export const ENV_KEYWORDS = ['dev', 'qa', 'prod', 'preprod'];

export const hasWhiteSpace = (value) => value?.indexOf(' ') >= 0;

export const containsEnvKeyword = (value) => {
    if (!value) return false;
    const lower = value.toLowerCase();
    return ENV_KEYWORDS.some((keyword) => lower.includes(keyword));
};

/**
 * Validates application short name
 * - Must be 2–10 characters
 * - Cannot contain environment keywords (dev, qa, prod, preprod)
 * - Cannot contain whitespace
 * @param {string} value
 * @returns {boolean}
 */
export const isValidAppShortName = (value) => !!value && !(value?.length < 2 || value?.length > 10) && !containsEnvKeyword(value) && !hasWhiteSpace(value);
